import {
  CoparticipationColumnIdEnum,
  CoparticipationSubRowColumnIdEnum,
  type ColumnsMainRowProps,
  type ColumnsSubRowProps,
} from '../types';

const columnsMainRow: ColumnsMainRowProps[] = [
  {
    id: CoparticipationColumnIdEnum.PartnerCompany,
    label: 'Contrato',
    align: 'left',
    width: '10%',
  },
  {
    id: CoparticipationColumnIdEnum.Beneficiary,
    label: 'Beneficiário',
    align: 'left',
    width: '25%',
  },
  {
    id: CoparticipationColumnIdEnum.Holder,
    label: 'Titular',
    align: 'left',
    width: '25%',
  },
  {
    id: CoparticipationColumnIdEnum.Total,
    label: 'Total',
    align: 'left',
    width: '15%',
  },
  {
    id: CoparticipationColumnIdEnum.CancelDate,
    label: 'Data Cancelamento',
    align: 'left',
    width: '20%',
  },
];

const columnsSubRow: ColumnsSubRowProps[] = [
  {
    id: CoparticipationSubRowColumnIdEnum.Code,
    label: 'Código',
    align: 'left',
    width: '10%',
  },
  {
    id: CoparticipationSubRowColumnIdEnum.Description,
    label: 'Descrição Procedimento',
    align: 'left',
    width: '25%',
  },
  {
    id: CoparticipationSubRowColumnIdEnum.Provider,
    label: 'Nome Prestador',
    align: 'left',
    width: '25%',
  },
  {
    id: CoparticipationSubRowColumnIdEnum.AuthorizationDate,
    label: 'Autorização',
    align: 'left',
    width: '15%',
  },
  {
    id: CoparticipationSubRowColumnIdEnum.Value,
    label: 'Valor Coparticipação',
    align: 'left',
    width: '20%',
  },
];

export { columnsMainRow, columnsSubRow };
